/**
 * Plan PBM — field-level effects.
 *
 * Migrated from: plan/plan-pbm-base.coffee
 *
 * Old validators → new effects:
 *   CopyPBMInfo  → CopyPBMInfo
 *   CopySPBMInfo → CopySPBMInfo
 *
 * Skipped:
 *   handle(dfd) init logic — no runtime init needed
 */
import { copyRelatedFields } from "@neu/libui";

// ─── CopyPBMInfo ───────────────────────────────────────────────────────────
// Old: DSLFx.Validators.CopyPBMInfo
// Trigger field: pbm_id
// Fetches PBM record and copies pcn, bin, phone, fax into form fields.
export const CopyPBMInfo = copyRelatedFields("pbm", {
	pcn: "pcn",
	bin: "bin",
	phone: "pbm_phone",
	fax: "pbm_fax",
});

// ─── CopySPBMInfo ──────────────────────────────────────────────────────────
// Old: DSLFx.Validators.CopySPBMInfo
// Trigger field: speciality_pbm_id
// Fetches PBM record and copies phone, fax into speciality PBM form fields.
export const CopySPBMInfo = copyRelatedFields("pbm", {
	phone: "speciality_pbm_phone",
	fax: "speciality_pbm_fax",
});
